@if (pbService.shouldShow()) {
  <div class="flex content-center items-center justify-center w-full pt-8 pb-80">
    <div class="spinner-container spinner-animation">
      <div class="shape shape1"></div>
      <div class="shape shape2"></div>
      <div class="shape shape3"></div>
      <div class="shape shape4"></div>
    </div>
  </div>
}